import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=5e4aedd6&"
import script from "./BarcodeScanner.ts?vue&type=script&lang=ts&"
export * from "./BarcodeScanner.ts?vue&type=script&lang=ts&"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=5e4aedd6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports